import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { ICreatePortfolio } from '@/modules/catalog/services/funds';
import { EPortfolioCreationFlow } from '@/modules/catalog/services/funds/funds-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'Conclusion',
  setup(__props) {

const router = useRouter();

const conclusionDetails = inject('conclusionDetails') as Ref<ICreatePortfolio>;

const details = computed(() => {
  return conclusionDetails.value.sheetCreate.portfolioInfo.items;
});

function goToPortfolio() {
  router.push({
    name: 'wealthPortfolio',
    params: {
      id: conclusionDetails.value.sheetCreate.portfolioInfo.apiId
    }
  });
}

function goToInvestment() {
  router.push({
    name: 'investment-transaction',
    params: {
      portfolio: conclusionDetails.value.sheetCreate.portfolioInfo.apiId
    }
  });
}

function goToNextStep() {
  const nextStep = {
    [EPortfolioCreationFlow.Invest]: goToInvestment,
    [EPortfolioCreationFlow.Preview]: goToPortfolio
  };
  nextStep[
    conclusionDetails.value.sheetCreate.portfolioInfo
      .buttonFlow as EPortfolioCreationFlow
  ]();
}

return { __sfc: true,router, conclusionDetails, details, goToPortfolio, goToInvestment, goToNextStep, ConclusionStep, ContentDisplay, Heading, ListDisplay, ButtonPrimary }
}

})